import styled from 'styled-components';
import {
	Checkbox,
	MAX_MD,
	MD_LG_PARA_1,
	MD_LG_PARA_2,
	MD_LG_TITLE,
	Spinner,
} from '@silverrailtech/srtlibrary';
import {
	baseContainerFillSecondary,
	interactionStrokeSubtle,
	limeGreen,
	textPrimary1,
	white,
} from '../../../colors';

export const InlineSpinner = styled(Spinner)`
	&& {
		height: 82px;
		left: 50%;
		position: absolute;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 110px;
		z-index: 1;
	}

	&& > div:last-child {
		${MD_LG_PARA_2}
		margin-top: 15px;
	}
`;

export const HeaderContentButton = styled.button`
	${MD_LG_PARA_2}
	align-items: center;
	background-color: transparent;
	border: 0;
	color: ${textPrimary1};
	cursor: pointer;
	display: flex;
	gap: 8px;
	height: 16px;
	padding: 0;
	text-align: left;
`;

export const BodyCellText = styled.span`
	${MD_LG_PARA_1}
	color: ${textPrimary1};
	white-space: nowrap;
`;

export const TableHeaderActions = styled.div`
	align-items: center;
	display: flex;
	justify-content: flex-end;
	min-height: 32px;
	padding-right: 8px;
	position: absolute;
	right: 0;
	top: 8px;
	z-index: 1;

	@media screen and (max-width: ${MAX_MD}) {
		margin-bottom: 8px;
		position: static;
	}
`;

export const SelectionCheckbox = styled(Checkbox)`
	&& {
		gap: 8px;
		justify-content: flex-end;

		.MuiCheckbox-root {
			padding: 0;
		}

		.MuiCheckbox-root.Mui-focusVisible svg {
			border-radius: 2px;
			outline: 2px solid ${limeGreen};
			outline-offset: 2px;
		}

		label {
			${MD_LG_PARA_2}
			color: ${textPrimary1};
		}
	}
`;

export const EmptyStateTitle = styled.p`
	${MD_LG_TITLE}
	color: ${textPrimary1};
	margin: 0;
`;

export const EmptyStateDescription = styled.p`
	${MD_LG_PARA_1}
	color: ${textPrimary1};
	margin: 2px 0 0;
`;

export default {
	tableContainer: {
		backgroundColor: 'transparent',
		border: 0,
		borderRadius: 0,
		marginTop: 16,
		overflowX: 'auto',
		position: 'relative',
		width: '100%',
	},
	table: {
		minWidth: 780,
		borderCollapse: 'separate',
		borderSpacing: '0 8px',
		tableLayout: 'fixed',
	},
	headerRow: {
		height: 32,
	},
	bodyRow: {
		height: 36,
	},
	headerCell: {
		borderBottom: 0,
		color: textPrimary1,
		padding: '0 8px',
		whiteSpace: 'nowrap',
	},
	activeSortIcon: {
		border: `1px solid ${limeGreen}`,
		borderRadius: '50%',
		boxSizing: 'border-box',
		color: limeGreen,
		opacity: 1,
	},
	sortIcon: {
		color: textPrimary1,
		fontSize: 16,
		flexShrink: 0,
		opacity: 0.7,
	},
	rowCellBase: {
		backgroundColor: white,
		borderBottom: `1px solid ${interactionStrokeSubtle}`,
		borderTop: `1px solid ${interactionStrokeSubtle}`,
		padding: '8px',
	},
	bodyCell: {
		whiteSpace: 'nowrap',
	},
	firstRowCell: {
		borderBottomLeftRadius: 4,
		borderLeft: `1px solid ${interactionStrokeSubtle}`,
		borderTopLeftRadius: 4,
	},
	lastRowCell: {
		borderBottomRightRadius: 4,
		borderRight: `1px solid ${interactionStrokeSubtle}`,
		borderTopRightRadius: 4,
	},
	emptyCell: {
		borderBottom: 0,
		padding: '8px 0 0',
	},
	emptyStateWrapper: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
	},
	emptyState: {
		backgroundColor: white,
		border: `1px solid ${interactionStrokeSubtle}`,
		borderRadius: 4,
		padding: '8px 16px',
		width: 458,
	},
	skeletonBlock: {
		backgroundColor: baseContainerFillSecondary,
		borderRadius: 2,
		height: 16,
	},
	loadingOverlay: {
		bottom: 0,
		left: 0,
		pointerEvents: 'none',
		position: 'absolute',
		right: 0,
		top: 40,
	},
};
